{
  "Job roles": "Yrkesroller",
  "My roles": "Mina roller",
  "Other roles": "Andra roller",
  "Add participants": "Lägg till deltagare",
  "Agent": "Agent",
  "automated": "automatisk",
  "Learning items": "Lärobjekt",
  "Assignment groups": "Tilldelningsgrupper",
  "Assignment group": "Tilldelningsgrupp",
  "Only published": "Endast publicerade",
  "No participants in the assignment group": "Inga deltagare i tilldelningsgruppen",
  "managed": "hanterad",
  "Manually added": "Manuellt tillagd",
  "Participants": "Deltagare",
  "participants": "deltagare",
  "Rules": "Regler",
  "Type": "Typ",
  "Assignments": "Tilldelningar",
  "Items": "Objekt",
  "mandatory": "Obligatorisk",
  "suggested": "Rekommenderad",
  "global": "Global",
  "role": "Roll",
  "in tab {{tab}}": "i tabb {{tab}}",
  "Removed Assignment group: {{name}}": "Tog bort Tilldelad grupp: {{name}}",
  "Assignment group created successfully": "Tilldelningsgrupp skapad",
  "Assignment group saved successfully": "Tilldelningsgrupp sparad",
  "Select type": "Välj typ",
  "Select a column": "Välj en kolumn",
  "Save rules": "Spara regler",
  "Preview changed rules": "Förhandsvisa ändrade regler",
  "rule": "regel",
  "rule_plural": "regler",
  "condition": "villkor",
  "participant": "deltagare",
  "assignment": "tilldelning",
  "published": "Publicerad",
  "unpublished": "Opublicerad",
  "not-published": "Not published",
  "Filter status": "Filtrera status",
  "Empty": "Tomt",
  "ANY": "någon",
  "ALL": "alla",
  "AND": "OCH",
  "OR": "ELLER",
  "Select all of the users that meet": "Välj alla de användare som matchar",
  "of these rules": "av dessa regler",
  "of these conditions": "av dessa villkor",
  "if": "om",
  "Add rule": "Lägg till regel",
  "Add condition": "Lägg till villkor",
  "E-mail addresses that couldn't be added": "E-postadresser som inte gick att lägga till",
  "users-added": "Lade till {{added}} deltagare",
  "users-added-with-duplicates": "Lade till {{added}} deltagare, {{duplicates}} existerande deltagare ignorerades",
  "users-added-none-with-duplicates": "Inga deltagare lades till och {{duplicates}} existerande deltagare ignorerades",
  "You successfully removed {{email}} from participants": "Du tog bort {{email}} från deltagarlistan",
  "Name": "Name",
  "Learners": "Learners",
  "Space": "Space",
  "Status": "Status",
  "auto-join-webinar": "Auto-join webinar for participants",
  "enable-automatic-webinar": "Enables automatic webinar seats for participants without manual intervention",
  "remove-learning-item-suffix": "learning item from this assignment"
}
